import { useNavigate } from 'react-router-dom'
import { useState, useEffect } from 'react'
import ImgRandomEventi from './imgRandomEventi'

function EventiItem({ dataInizio, dataFine, tipologia, titolo, img, userId, comune, provincia, id, accettazione, url, view }) {
    const navigate = useNavigate()
    const today = new Date()
    today.setDate(today.getDate() - 1) //tolgo un giorno alla data odierna
    const tomorrow = new Date(today).toISOString()//valorizzo tomorrow con la data di domani

    const [fotoDaScegliere, setFotoDaScegliere] = useState([])
    const [fotoScelta, setFotoScelta] = useState('')

    const imgArray = img.split(',')
    let data; let opaco = 1
    if (accettazione === 'null' || dataFine < tomorrow) (opaco = 0.5)

    if (dataInizio !== dataFine) {
        data = <p>Dal <b>{dataInizio.split("-").reverse().join("-")}</b> al <b>{dataFine.split("-").reverse().join("-")}</b></p>
    } else data = <p><b>{dataInizio.split("-").reverse().join("-")}</b></p>

    useEffect(() => {
        const itemScelto = fotoDaScegliere.find(item => item.tipologia === tipologia)
        if (itemScelto && !img) {
            const arrayFoto = itemScelto.foto; // Prende l'array di foto corretto
            const indiceCasuale = Math.floor(Math.random() * arrayFoto.length)
            setFotoScelta(arrayFoto[indiceCasuale])
        }
    }, [fotoDaScegliere])

    return (<>
        <br />
        <ImgRandomEventi onDataSubmit={(e) => { setFotoDaScegliere(e) }} />
        <div className="col">
            <div className="card" style={{ opacity: opaco, cursor: 'pointer' }} onClick={() => {
                navigate(`/eventiDetails/${id}`, { state: { fotoScelta } })
            }}>
                {img ?
                    <img src={`https://leuro-bucket.s3.amazonaws.com/${imgArray[0]}`} className="card-img-top" height={400} style={{ objectFit: 'cover' }} alt='' />
                    :
                    fotoScelta ? <img src={`https://leuro-bucket.s3.amazonaws.com/imgRandomEventi/${fotoScelta}`} height={400} className='rounded'
                        style={{ objectFit: 'cover' }} alt='' />
                        :
                        <img src={`https://leuro-bucket.s3.amazonaws.com/evento_senza_foto.jpg`} className="card-img-top" alt='' />
                }
                <div className="card-body">
                    <h5 className="card-title"><b>{titolo}</b></h5>
                    {data}
                    <p>{comune.charAt(0).toUpperCase() + comune.slice(1)} ({provincia.toUpperCase()})
                    </p>
                    <p style={{
                        display: 'inline',
                        color: 'white',
                        backgroundColor: 'maroon',
                        width: 'max-content',
                        padding: '5px',
                    }}>{tipologia}
                    </p> <span className='float-end'>View: {view}</span>
                    {accettazione === 'null' ?
                        <p style={{
                            marginTop: '1rem',
                            backgroundColor: 'black',
                            color: 'white',
                            padding: '3px',
                            border: '3px solid black',
                            textAlign: 'center',
                            fontSize: 'x-large'
                        }}><b>EVENTO ANNULLATO</b>
                        </p> : null}
                </div>
            </div>
        </div>
    </>)
}
export default EventiItem